document.addEventListener('DOMContentLoaded', function () {
  const scrollToTopButton = document.querySelector('.scroll-to-top');

  if (scrollToTopButton) {
    scrollToTopButton.addEventListener('click', function() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }, false)
  }

  const productBarcode = document.getElementById('ProductID');

  if (productBarcode) {

    function updateProductBarcode(evt) {
      productBarcode.innerHTML = evt.detail.variant.barcode;
    }
  
    document.addEventListener('variant:change', updateProductBarcode);
  }

  const addToCartWrapper = document.querySelector('.add-to-cart-wrapper');

  if (addToCartWrapper) {

    const addToCartWrapperShadow = document.querySelector('.add-to-cart-wrapper--shadow');
    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 1.0,
    };

    var observer = new IntersectionObserver(function (entries) {
      if (entries[0].intersectionRatio < 1) {
        addToCartWrapperShadow.style.height = window.innerWidth < 1025 ? "60px" : "46px";
        addToCartWrapper.classList.add('add-to-cart-wrapper--sticky');
      } else {
        addToCartWrapperShadow.style.height = "0";
        addToCartWrapper.classList.remove('add-to-cart-wrapper--sticky');
      }
    }, observerOptions);
    
    observer.observe(addToCartWrapperShadow);
  }

  const productPreOrderPropertyInput = document.querySelector('#Product-Pre-Order-Property');

  if (productPreOrderPropertyInput) {
    document.addEventListener('variant:change', function(evt) {
      if (evt.detail.variant.inventory_quantity == 0 && evt.detail.variant.inventory_policy == "continue") {
        productPreOrderPropertyInput.disabled = false;
      } else {
        productPreOrderPropertyInput.disabled = true;
      }
    });
  }
});

// Keep drawer removal asynchronous; the full cart page must navigate to fresh HTML.
document.addEventListener('click', (e) => {
  const link = e.target.closest('#CartDrawer .cart__remove a');
  if (!link) return;

  e.preventDefault();                       // stop redirect
  const key = new URL(link.href).searchParams.get('id');

  fetch('/cart/change.js', {
    method:  'POST',
    headers: { 'Content-Type': 'application/json' },
    body:    JSON.stringify({ id: key, quantity: 0 })
  })
    .then((r) => (r.ok ? r.json() : Promise.reject(r)))
    .then(() => {
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      document.dispatchEvent(new Event('cart:open'));
    });
});
